<template>
<div class="monthly-date-picker">
    <div class="month-calendar-header">
        {{year}}年{{month+1}}月
    </div>
    <div class="month-calendar-ctn">
          <span v-for="weekday in weeks" :key="weekday" class="month-calendar-cell header">
            {{weekday}}
          </span>
          <span v-for="dateItem in daysInMonthFormated" 
                :class="classes(dateItem)"
                :key="dateItem.timestamp"
                @click="onClickDateHandler(dateItem)">
              <span v-if="isDateGroupBound(dateItem)=='start'&&selectable(dateItem)" class="selected-flag-sp">首次课</span>
              <span v-else-if="isDateGroupBound(dateItem)=='end'&&selectable(dateItem)" class="selected-flag-sp">末次课</span>
              <span class="month-canlendar-cell-inner">{{dateItem.date}}</span>
              <span class="day-course-times"></span>
          </span>
    </div>
</div>
</template>
<script>
import './MonthlyDatePicker.less'
export default {
  name: 'MonthlyDatePicker',
  props: {
    year: Number,
    month: Number,
    datesGroup: Array,
    selectMode: String,
    datesGroupSelectedStart: Object,
    datesGroupSelectedEnd: Object,
    selectedDateGroupMap: Object
  },
  data(){
    return {
      daysInMonthFormated: [],
      weeks: ['日', '一', '二', '三', '四', '五', '六']
    }
  },
  methods: {
    init (){
      //按月取日历
      var daysInMonth = this.getDaysInMonth(this.month, this.year);//获取当前月份有多少天
      var monthStartDate = new Date(this.year, this.month, 1);//月份开始的日期
      var monthEndDate = new Date(this.year, this.month, daysInMonth);//月份结尾的日期
      daysInMonth = this.getAllDays(monthStartDate, monthEndDate);//一个月的所有信息
      var predays = [];//填充开始的日期之前的

      if (daysInMonth[0].day!=0){ //开始日期是星期几 如周三
        for (var i=0;i<daysInMonth[0].day;i++){
          var temp = new Date(daysInMonth[0].timestamp-(1000*3600*24*(i+1)));
          predays.unshift({
            timestamp: temp.valueOf(),
            month: temp.getMonth(),
            date: temp.getDate(),
            day: temp.getDay(),
            isPre: true
          });
        }
      }
      this.daysInMonthFormated = predays.concat(daysInMonth);
    },
    componentWillReceiveProps(){
      this.init();
    },
    getDaysInMonth(month, year){
      var daysInMonth=[31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
      if ((month==1)&&(year%4==0)&&((year%100!=0)||(year%400==0))){
        return 29;
      } else {
        return daysInMonth[month];
      }
    },
    getAllDays(startDate, endDate){
      var result = [];
      for (var k=startDate.valueOf();k<=endDate.valueOf();){ //循环当月的所有日期

        var temp = new Date(k);//月份开始的日期
        var tempFmt = utils.formatDate(temp, 'yyyy-MM-dd');
        var inDateGroup = _.find(this.datesGroup, {date: tempFmt});//找到开始的日期是不是在headers里面
        if (inDateGroup){
          result.push({
            dateFmt: tempFmt,
            year: temp.getFullYear(), // 年
            timestamp: temp.valueOf(), // 时间戳
            month: temp.getMonth(), // 月
            date: temp.getDate(), // 日
            day: temp.getDay(), // 星期几
            dateType: inDateGroup.dateType, // 是否可选
            dateValue: inDateGroup.dateValue,
            dateMsg: inDateGroup.dayMsg,
            groupId: inDateGroup.groupId, // 课程id
            highlight: inDateGroup.highlight, // 表头是否高亮
            today: inDateGroup.today,
            tomorrow: inDateGroup.tomorrow,
            thisweek: inDateGroup.thisweek,
            nextweek: inDateGroup.nextweek
          });
        } else {
          result.push({
            dateFmt: tempFmt,
            dateType: 0, //当前日期不可选
            year: temp.getFullYear(), //年
            timestamp: temp.valueOf(), //时间戳
            month: temp.getMonth(), //月
            date: temp.getDate(), //日
            day: temp.getDay(), //星期几
            highlight: 0//表头不高亮
          });
        }

        k = k+(1000*60*60*24);//month+1
      }
      return result;
    },
    onClickDateHandler(date){
      this.$emit('onDateChangeHandler', date);
    },
    /**
     * 判断是否能选中，能选中约束如下：
     * 1、groupId在selectDateGroup中
     * 2、如果是selectMode为0，同一个groupId的均可选中
     *    如果selectMode为1，之后点击日期之后的相同groupId的才能被选中
     * */
    selectable(date){
      var groupInfo = this.selectedDateGroupMap[date.groupId];
      if (!groupInfo){
        return false;
      } else if (this.selectMode==0){
        return true;
      } else if (this.selectMode==1){
        var dateValue = groupInfo.dateValue;
        var endDate = dateValue.split('|')[1];
        if (date.timestamp>=groupInfo.timestamp&&date.dateFmt<=endDate){
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    /**
     * 判断是否是日期的边界，selectMode为1时，结束边界值由startDate中的dateValue决定
     * 否则等同于endDate
     * */
    isDateGroupBound(dateItem){
      if (this.datesGroupSelectedStart&&this.datesGroupSelectedStart.date==dateItem.dateFmt){
        return 'start';
      } else if (this.selectMode=='1'&&this.datesGroupSelectedStart){
        var dateValue = this.datesGroupSelectedStart.dateValue;
        var endDate = dateValue.split('|')[1];
        if (dateItem.dateFmt==endDate){
          return 'end'
        } else {
          return '';
        }
      } else if (this.datesGroupSelectedEnd&&this.datesGroupSelectedEnd.date==dateItem.dateFmt){
        return 'end';
      } else {
        return '';
      }
    },
    classes(dateItem){
      return ['month-calendar-cell rel', {
        today: dateItem.today,
        start: dateItem.day==0,
        prev: dateItem.isPre,
        disabled: dateItem.highlight==0,
        selected: this.selectable(dateItem),
        selectedflag: this.isDateGroupBound(dateItem)
      }];
    }
  },
  mounted(){
    this.init();
  }
}
</script>


// WEBPACK FOOTER //
// src/components/courseCenter/newsign/MonthlyDatePicker.vue